

import React, { useState, useEffect } from "react";
import "./Myordermain.css";
import Myorder from './Myorder';
import Tableordertype from './Tableordertype'
import Cateringmainorder from './Cateringmainorder'
import { useLocation } from "react-router-dom";

/* ---------- Main Company Component ---------- */
const Company = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(null);
  const [tabs, setTabs] = useState([]);

  // Define all available tabs with their submodule mapping
  const allTabs = [
    { 
      id: 1, 
      name: "Food", 
      component: () => <Myorder title="FOOD & BEVERAGES" />,
      subModuleKey: "ABOUT_US"
    },
    { 
      id: 2, 
      name: "catring-Orders", 
      component: () => <Cateringmainorder title="Company Structure" />,
      subModuleKey: "catring-Orders"
    },
    { 
      id: 3, 
      name: "Tbale-Orders", 
      component: () => <Tableordertype title="Company Structure" />,
      subModuleKey: "Tbale-Orders"
    },
  ];

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    const subModules = JSON.parse(localStorage.getItem("subModules") || "[]");

    let availableTabs = [];

    if (userRole === "ROLE_EMPLOYEE") {
      availableTabs = allTabs.filter(tab =>
        subModules.includes(tab.subModuleKey)
      );
      //console.log("Employee - Available subModules:", subModules);
      //console.log("Employee - Available tabs:", availableTabs);
    } else {
      availableTabs = [...allTabs];
      //console.log("Vendor - Showing all tabs");
    }

    setTabs(availableTabs);

    // PRIORITY 1: Check location state first
    const stateTab = location.state?.activeTab;
    
    // PRIORITY 2: Check localStorage
    const savedTab = localStorage.getItem("activeTab");
    
    // PRIORITY 3: Use default (first tab)

    //console.log("STATE TAB:", stateTab);
    //console.log("SAVED TAB:", savedTab, "Type:", typeof savedTab);
    //console.log("LOCATION STATE:", location.state);

    if (availableTabs.length > 0) {
      // FIRST PRIORITY - location.state (most reliable)
      if (stateTab !== undefined && stateTab !== null) {
        //console.log("Setting tab from STATE:", stateTab);
        setActiveTab(stateTab);
        // Clean up localStorage if it exists
        if (savedTab) localStorage.removeItem("activeTab");
      } 
      // SECOND PRIORITY - localStorage
      else if (savedTab !== null && savedTab !== undefined) {
        const tabNumber = Number(savedTab);
        //console.log("Setting tab from localStorage:", tabNumber);
        setActiveTab(tabNumber);
        localStorage.removeItem("activeTab");
      } 
      // THIRD PRIORITY - default first tab
      else {
        //console.log("Setting default tab:", availableTabs[0].id);
        setActiveTab(availableTabs[0].id);
      }
    }
  }, [location]); // Re-run when location changes

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  // If no tabs available, show a message
  if (tabs.length === 0) {
    return (
      <div className="company-container">
        <div style={{ 
          textAlign: "center", 
          padding: "50px",
          color: "#64748b"
        }}>
          <h3>No modules available</h3>
          <p>You don't have access to any modules in this section.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="company-container">
      <style>{`
        /* Default (Mobile first) */
        .company-scroll-container {
          position: static;
          background: #fff;
        }
      
        .company-buttons-row {
          display: flex;
          flex-wrap: wrap;
        }
      
        .company-button {
          padding: 8px 16px;
          border: none;
          background: #f0f0f0;
          cursor: pointer;
          border-radius: 6px;
          white-space: nowrap;
        }
      
        .company-button.active {
          background: #e66d33;
          color: #fff;
        }
      
        /* Desktop / Laptop only */
        @media (min-width: 769px) {
          .company-scroll-container {
            position: sticky;
            top: 0;
            z-index: 100;
            padding: 10px 0;
          }
        }
      `}</style>

      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display" style={{height: window.innerHeight < 450 ? "50vh" : 
        window.innerHeight < 500 ? "55vh" :
        window.innerHeight < 520 ? "60vh" :
        window.innerHeight < 540 ? "62vh" :
        window.innerHeight < 560 ? "64vh" :
        window.innerHeight < 580 ? "66vh" :
        window.innerHeight < 600 ? "68vh" :
        window.innerHeight < 620 ? "69vh" :
        window.innerHeight < 640 ? "69vh" :
        window.innerHeight < 660 ? "70vh" :
        window.innerHeight < 680 ? "71vh" :
        window.innerHeight < 700 ? "72vh" :
        window.innerHeight < 720 ? "73vh" :
        window.innerHeight < 740 ? "77vh" :
        window.innerHeight < 760 ? "80vh" :
        window.innerHeight < 780 ? "80vh" :
        window.innerHeight < 800 ? "80vh" : "80vh"}}>
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Company;
